import { useTranslation } from "react-i18next";
import WTypography from "../wtypography/WTypography";
import Link from "next/link";

/* eslint-disable-next-line */
export interface LAppDownloadIconsProps {
  withTitle?: boolean;
}

export function LAppDownloadIcons({
  withTitle = false,
}: LAppDownloadIconsProps) {
  const { t: tCommon } = useTranslation("common");

  return (
    <div className="flex flex-col gap-4">
      {withTitle && (
        <WTypography
          text={tCommon("download-edukiwischool")}
          className="text-ekgreen"
          type="medium"
        />
      )}
      <div className="flex flex-col items-center gap-4 lg:flex-row">
        <Link
          href="https://apps.apple.com/rs/app/edukiwi-school/id1638696333"
          passHref
          target="_blank"
          rel="noreferrer"
        >
          <img src="/img/apple-store.png" alt="EduKiwiSchool Apple Store" />
        </Link>
        <Link
          href="https://play.google.com/store/apps/details?id=com.edukiwi.edukiwischoolapp"
          passHref
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="/img/google-store.png"
            alt="EduKiwiSchool Google Play Store"
          />
        </Link>
      </div>
    </div>
  );
}

export default LAppDownloadIcons;
